/**
 * 编辑回看视频信息
 * Create by liaokai on 2020-06-19 16:08:17
 */
import * as React from 'react';
import {Component} from "react";
import { message, Modal} from "antd";
import {ICoursewareIndexItem} from "../../../../../../../common/apis/apis/live/coursewareIndex";
import {TitleContentTable} from "../../../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";
import {coursewarePublish} from "../../../../../../../common/apis/apis/live/coursewarePublish";
import {liveStore} from "../../live.store";


interface IProps{
    visible : boolean
    onCancel? : () => void
    onSubmit? : (msg:string) => void
    item : ICoursewareIndexItem|undefined
}

interface IState{
}

export class DownloadPublish extends Component<IProps,IState>{
    readonly state : IState = {
    };

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        // if(JSON.stringify(this.props.id) !== JSON.stringify(prevProps.id) ){
        //     this.setState({editItem : this.props.editItem ?? defaultItem})
        // }
    }

    render() {
        let {onCancel,onSubmit,visible,item} = this.props;
        let {} = this.state;
        let statusStr = item?.status === 1 ? "取消发布":"发布"
        return (
            <Modal
                visible={visible}
                onCancel={()=>{
                    onCancel?.();
                }}
                onOk={()=>{
                    // console.log(this.props)
                    coursewarePublish({live_courseware_id:item?.id.toString()}).then(()=>{
                        onSubmit?.(statusStr+'成功')
                        onCancel?.()
                    }).catch(e => {
                        message.error(statusStr+"失败 " + e.data?.message)
                    })
                }}
                cancelText={"取消"}
                okText={"确认"}
                title={statusStr}
            >
                <TitleContentTable colGap={10} rowGap={10}>
                    <div>{`您确认${statusStr}么？`}</div>
                </TitleContentTable>
            </Modal>
        );
    }
}
